import React from 'react';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';
import { CommunicationHub } from 'components';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const BrandCommunicationHub = React.memo(() => {
  const { hasAccess } = useAccessControl();
  return (
    <HasAccess role={PERMISSIONS.notes.note.read}>
      <CommunicationHub
        entity={'BRAND'}
        hasAccessToWrite={hasAccess(PERMISSIONS.notes.note.write)}
        hasAccessToOtherNoteWrite={hasAccess(PERMISSIONS.notes.other_note.write)}
        hasAccessToOtherNoteDelete={hasAccess(PERMISSIONS.notes.other_note.delete)}
      />
    </HasAccess>
  );
});
